export const schema = (type, data) => JSON.stringify({
    "@context": "https://schema.org",
    "@type": type,
    ...data
})